module.exports = __webpack_public_path__ + "static/media/Toren_SemiClose_2@2x.3451825f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/03/assets/Toren_SemiClose_2@2x.jpg
// module id = 568
// module chunks = 0